module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600-c7f395807f2a6952eed205acc5175402.webp";